const ShortEssayScored = () => <p>Short Essay Scored</p>;
export default ShortEssayScored;
